import { I18n } from '@calendly/i18n';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment';
import { useMemo, forwardRef } from 'react';
import { formatTime, parseTime, shortUserDateRangeFormatWithNoYear, userDateFormat } from 'services/time_format';
const intervalWrapperCss = "i1vufxfv";
const IntervalWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(intervalWrapperCss, props.className)} />;
});
const cellWithoutPaddingCss = "c1b2kbd8";
const cellCss = "c1857g52";
const Cell = forwardRef((props, ref) => {
  const {
    withoutPadding,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cellCss, {
    [cellWithoutPaddingCss]: withoutPadding
  }, props.className)} />;
});
const Interval = ({
  from,
  to,
  timeNotation
}) => {
  const intervalStart = parseTime(from);
  const intervalEnd = parseTime(to);
  return <IntervalWrapper>
      {formatTime(intervalStart, timeNotation)}
      {' – '}
      {formatTime(intervalEnd, timeNotation)}
    </IntervalWrapper>;
};
export const IntervalsContainer = ({
  intervals,
  timeNotation,
  withoutPadding
}) => <Cell withoutPadding={withoutPadding}>
    {intervals.length === 0 ? I18n.t('publisher.event_types.availability.unavailable') : intervals.map(({
    from,
    to
  }) => <Interval key={`${from}-${to}`} from={from} to={to} timeNotation={timeNotation} />)}
  </Cell>;
export const Date = ({
  dateRange,
  withoutPadding
}) => {
  const textContent = useMemo(() => {
    const fromDate = moment(dateRange[0]);
    const toDate = moment(dateRange[dateRange.length - 1]);
    if (dateRange.length === 1) {
      return userDateFormat(fromDate, 'american', 'date_small');
    }
    const [rangeStart, rangeEnd] = shortUserDateRangeFormatWithNoYear(fromDate, toDate);
    return `${rangeStart} – ${rangeEnd}`;
  }, [dateRange]);
  return <Cell withoutPadding={withoutPadding}>
      <BodyText size="medium" weight="semibold">
        {textContent}
      </BodyText>
    </Cell>;
};
export const ShowMoreButton = ({
  isExpanded,
  onClick,
  totalRules
}) => <div>
    <MinimalButton onClick={onClick} aria-expanded={isExpanded} size="small">
      <LabelText size="medium">
        {isExpanded ? I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.show_less') : I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.show_more', {
        count: totalRules
      })}
      </LabelText>
      {isExpanded ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
    </MinimalButton>
  </div>;

require("./components.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./components.js");